import { anmClassificationCatalogPtBR } from "./anm-classification/pt-BR";
import { inspectionPtBR } from "./inspection/pt-BR";
import { regionalClassificationCatalogPtBR } from "./regional-classification/pt-BR";

export const ptBR = {
  inspection: inspectionPtBR,
  test: "Se você está vendo isso, o i18next está funcionando!",
  operationalPermissions: {
    keys: {
      view: "Visualizar",
      create: "Criar",
      update: "Editar",
      delete: "Excluir",
      upload: "Enviar arquivo",
      download: "Baixar",
    },
  },
  operationalModules: {
    selector: {
      title: "Selecione uma estrutura",
      empty: "Nenhuma estrutura disponível para este módulo.",
    },
    placeholder: {
      underConstruction: "Este módulo está em construção.",
    },
  },
  general: {
    comingSoon: {
      title: "Em breve",
      description: "Este tipo de estrutura ainda não possui dashboard no módulo Geral.",
    },
    dashboard: {
      emptyValue: "—",
      loadError: "Erro ao carregar os dados.",
      button: {
        close: "Fechar",
      },
      pagination: {
        showing: "Página {{current}} de {{total}}",
        previous: "Anterior",
        next: "Próximo",
      },
      anmClassification: {
        title: "Classificação ANM",
        modalTitle: "Ficha de Classificação ANM",
        dpa: "Dano Potencial Associado",
        cri: "Classificação de Risco",
        go: "Gestão Operacional",
        sections: {
          ct: "Características Técnicas",
          ec: "Estado de Conservação",
          psb: "Plano de Segurança",
          dpa: "Dano Potencial Associado",
          go: "Gestão Operacional",
        },
      },
      regionalClassification: {
        title: "Classificação Regional",
        modalTitle: "Ficha de Classificação Regional",
        dpa: "Dano Potencial Associado",
        cri: "Classificação de Risco",
        state: "Estado:",
        norm: "Norma:",
        selectionsTitle: "Seleções da Norma Regional",
      },
      classificationDetail: {
        resultTitle: "Resultado da classificação",
        criteriaTitle: "Detalhamento por critério",
        subtotal: "Subtotal",
      },
      generalData: {
        title: "Dados Gerais",
        modalTitle: "Ficha de Dados Gerais",
        responsibleCompany: "Empresa Responsável:",
        operationStartDate: "Início da operação:",
        operationEndDate: "Fim da operação:",
        coordinateSystem: "Sistema de coordenadas:",
      },
      tenantSummary: {
        title: "GS3 / Cliente",
        modalTitle: "Ficha do Cliente",
        logoAlt: "Logo do cliente",
        clientName: "Cliente:",
        fantasyName: "Nome Fantasia:",
        cnpj: "CNPJ:",
        cep: "CEP:",
        responsibleName: "Responsável:",
      },
      complex: {
        title: "Complexo",
        modalTitle: "Ficha do Complexo",
        name: "Complexo:",
        cnpj: "CNPJ:",
        cep: "CEP:",
        responsibleName: "Responsável:",
      },
      hydrology: {
        title: "Hidrologia:",
      },
      raisingHistory: {
        title: "Histórico de Alteamento:",
        modalTitle: "Histórico de Alteamento",
      },
      geometry: {
        title: "Geometria do maciço:",
        modalTitle: "Ficha de Geometria",
      },
      reservoirManagement: {
        title: "Manejo do reservatório:",
        modalTitle: "Manejo do reservatório",
      },
      riskMapping: {
        title: "Mapeamento de Risco:",
      },
      map: {
        title: "Mapa",
        noCoordinates: "Nenhuma coordenada cadastrada",
      },
    },
  },
  sidebar: {
    modules: {
      general: "Geral",
      monitoring: "Monitoramento",
      inspection: "Inspeção",
      actionPlan: "Plano de Ação",
      stabilityAnalysis: "Análise de Estabilidade",
      eor: "Engenheiro de Registro (EoR)",
      ato: "ATO",
      psb: "PSB",
      gistm: "GISTM",
      paebm: "PAEBM",
      damBreakStudy: "Estudo de Ruptura",
      riskAnalysis: "Análise de Risco",
    },
  },
  auth: {
    selectClient: "Selecione o cliente",
    management: "Gerencial",
    loadingOrganizations: "Carregando organizações...",
    errorLoadingOrganizations: "Erro ao carregar organizações",
    errorSelectingTenant: "Erro ao selecionar organização",
    tryAgain: "Tentar Novamente",
    logout: "Sair",
    loading: "Carregando...",
    permissionDenied: "Você não tem permissão",
    pagePermissionDenied: "Você não tem permissão para acessar essa página.",
    authError:
      "Erro ao verificar autenticação. Tente novamente. Se o problema persistir entre em contato com o suporte",
    permissionError: "Erro ao verificar permissões",
  },
  common: {
    notFoundPage: {
      title: "Página não encontrada",
      description:
        "Desculpe, a página que você está procurando não existe ou foi movida.",
      backToHome: "Voltar ao início",
      goBack: "Voltar",
    },
    tellusAllRightsReserved:
      "Tellus Company® 2025 Todos os direitos reservados",
    error: "Erro",
    management: "Gerenciamento",
    admin: "Admin",
    item: "Item",
    loading: "Carregando...",
    deleteModalTitle: "Excluir item permanentemente",
    deleteModalItemMessage: "Item a ser excluído:",
    deleteModalAlertMessage:
      " Esta ação é irreversível. Os dados não poderão ser recuperados após a exclusão.",
    delete: "Excluir",
    deleting: "Excluindo...",
    cancel: "Cancelar",
    toggleTheme: "Alternar tema",
    deleteSuccess: "Exclusão bem-sucedida",
    createSuccess: "Criação bem-sucedida",
    editSuccess: "Edição bem-sucedida",
    errorCreating: "Erro ao criar",
    errorEditing: "Erro ao editar",
    errorDeleting: "Erro ao excluir",
    address: {
      countries: {
        brazil: "Brasil",
      },
      states: {
        acre: "Acre",
        alagoas: "Alagoas",
        amapa: "Amapá",
        amazonas: "Amazonas",
        bahia: "Bahia",
        ceara: "Ceará",
        distritoFederal: "Distrito Federal",
        espiritoSanto: "Espírito Santo",
        goias: "Goiás",
        maranhao: "Maranhão",
        matoGrosso: "Mato Grosso",
        matoGrossoDoSul: "Mato Grosso do Sul",
        minasGerais: "Minas Gerais",
        para: "Pará",
        paraiba: "Paraíba",
        parana: "Paraná",
        pernambuco: "Pernambuco",
        piaui: "Piauí",
        rioDeJaneiro: "Rio de Janeiro",
        rioGrandeDoNorte: "Rio Grande do Norte",
        rioGrandeDoSul: "Rio Grande do Sul",
        rondonia: "Rondônia",
        roraima: "Roraima",
        santaCatarina: "Santa Catarina",
        saoPaulo: "São Paulo",
        sergipe: "Sergipe",
        tocantins: "Tocantins",
      },
    },
  },
  pagination: {
    rowsPerPage: "Linhas por página",
    pageOf: "Página {{current}} de {{total}}",
    goToPage: "Ir para página",
    goToPageAriaLabel: "Ir para página",
    showingRange: "Mostrando {{start}}–{{end}} de {{total}}",
    showingEmpty: "Nenhum registro encontrado",
  },
  management: {
    navbar: {
      management: "Gerencial",
      users: "Usuários",
      clients: "Clientes",
      complexes: "Complexos",
      structures: "Estruturas",
      licenses: "Licenças",
      log: "Logs",
      releaseNotes: "Notas de Versão",
      termsOfUse: "Termos de Uso",
      privacyPolicy: "Política de Privacidade",
    },
    users: {
      button: {
        new: "Novo Usuário",
        save: "Salvar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Excluir",
        filter: "Filtrar",
        clearFilters: "Limpar Filtros",
      },
      form: {
        label: {
          name: "Nome",
          email: "Email",
          role: "Tipo de acesso",
          phone: "Telefone",
          department: "Setor",
          position: "Função",
        },
        placeholder: {
          name: "Nome Sobrenome",
          email: "nome@empresa.com",
          roleSelect: "Selecione...",
          department: "Engenharia digital",
          position: "UX/UI Designer",
          filterName: "Digite o nome",
          filterEmail: "Digite o email",
          filterRole: "Selecione o tipo de usuário...",
        },
      },
      table: {
        column: {
          name: "Nome",
          email: "Email",
          role: "Tipo de Acesso",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Cadastrar usuário",
          edit: "Editar usuário",
        },
      },
      filter: {
        status: {
          active: "Ativo",
          inactive: "Inativo",
        },
      },
      validation: {
        nameRequired: "Nome é obrigatório",
        emailInvalid: "Email inválido",
        emailRequired: "Email é obrigatório",
        roleRequired: "Tipo de acesso é obrigatório",
        phoneRequired: "Telefone é obrigatório",
      },
    },
    complexes: {
      button: {
        new: "Novo Complexo",
        save: "Salvar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Excluir",
        filter: "Filtrar",
        clearFilters: "Limpar Filtros",
      },
      form: {
        section: {
          generalData: "Dados Gerais",
          address: "Endereço",
          responsible: "Responsável",
        },
        label: {
          cnpj: "CNPJ",
          tradeName: "Nome de Exibição",
          companyPhone: "Telefone (empresa)",
          municipalRegistration: "Inscrição Municipal",
          logo: "Logo",
          zipCode: "CEP",
          street: "Logradouro",
          complement: "Complemento",
          neighborhood: "Bairro",
          number: "Número",
          city: "Cidade",
          state: "Estado",
          country: "País",
          responsibleName: "Nome",
          responsibleEmail: "Email",
          responsiblePhone: "Telefone (responsável)",
          complex: "Complexo",
          phone: "Telefone",
          responsible: "Responsável",
        },
        placeholder: {
          cnpj: "00.000.000/0000-00",
          complex: "Complexo",
          tradeName: "Nome de Exibição",
          companyPhone: "(00) 00000-0000",
          municipalRegistration: "123456789",
          zipCode: "00000-000",
          street: "Rua, Avenida, etc",
          complement: "Sala, Andar, etc",
          neighborhood: "Nome do bairro",
          number: "123",
          city: "Nome da cidade",
          state: "Selecione o estado",
          country: "Selecione o país",
          responsibleName: "Nome Sobrenome",
          responsibleEmail: "nome@empresa.com",
          responsiblePhone: "(00) 00000-0000",
          filterComplex: "Digite o nome do complexo",
          filterPhone: "Digite o telefone",
          filterResponsible: "Digite o nome do responsável",
        },
      },
      table: {
        column: {
          complex: "Complexo",
          phone: "Telefone",
          responsible: "Responsável",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Cadastrar complexo",
          edit: "Editar complexo",
        },
      },
      validation: {
        cnpjRequired: "CNPJ é obrigatório",
        cnpjInvalid: "CNPJ inválido. Formato esperado: 00.000.000/0000-00",
        companyRequired: "Empresa é obrigatória",
        tradeNameRequired: "Nome de exibição é obrigatório",
        companyPhoneRequired: "Telefone da empresa é obrigatório",
        telefoneInvalid: "Telefone inválido. Formato esperado: (00) 00000-0000",
        municipalRegistrationRequired: "Inscrição Municipal é obrigatória",
        logoRequired: "Logo é obrigatória",
        logoInvalidType: "Logo deve ser uma imagem JPEG, JPG ou PNG",
        zipCodeRequired: "CEP é obrigatório",
        zipCodeInvalid: "CEP inválido. Formato esperado: 00000-000",
        streetRequired: "Logradouro é obrigatório",
        neighborhoodRequired: "Bairro é obrigatório",
        numberRequired: "Número é obrigatório",
        numberInvalid: "Informe um número inteiro válido",
        cityRequired: "Cidade é obrigatória",
        stateRequired: "Estado é obrigatório",
        countryRequired: "País é obrigatório",
        responsibleNameRequired: "Nome do responsável é obrigatório",
        responsibleEmailRequired: "Email do responsável é obrigatório",
        emailInvalid: "Email inválido",
        responsiblePhoneRequired: "Telefone do responsável é obrigatório",
      },
    },
    clients: {
      button: {
        new: "Novo Cliente",
        save: "Salvar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Excluir",
        filter: "Filtrar",
        clearFilters: "Limpar Filtros",
      },
      form: {
        section: {
          generalData: "Dados Gerais",
          address: "Endereço",
          responsible: "Responsável",
        },
        label: {
          cnpj: "CNPJ",
          company: "Empresa",
          tradeName: "Nome Fantasia",
          companyPhone: "Telefone (empresa)",
          municipalRegistration: "Inscrição Municipal",
          logo: "Logo",
          zipCode: "CEP",
          street: "Logradouro",
          complement: "Complemento",
          neighborhood: "Bairro",
          number: "Número",
          city: "Cidade",
          state: "Estado",
          country: "País",
          responsibleName: "Nome",
          responsibleEmail: "Email",
          responsiblePhone: "Telefone (responsável)",
          client: "Cliente",
          responsible: "Responsável",
        },
        placeholder: {
          cnpj: "00.000.000/0000-00",
          company: "Nome da empresa",
          tradeName: "Nome fantasia",
          companyPhone: "(00) 00000-0000",
          municipalRegistration: "123456789",
          zipCode: "00000-000",
          street: "Rua, Avenida, etc",
          complement: "Sala, Andar, etc",
          neighborhood: "Nome do bairro",
          number: "123",
          city: "Nome da cidade",
          state: "Selecione o estado",
          country: "Selecione o país",
          responsibleName: "Nome Sobrenome",
          responsibleEmail: "nome@empresa.com",
          responsiblePhone: "(00) 00000-0000",
          filterClient: "Digite o nome do cliente",
          filterTradeName: "Digite o nome fantasia",
          filterCnpj: "Digite o CNPJ",
          filterResponsible: "Digite o nome do responsável",
        },
      },
      table: {
        column: {
          client: "Cliente",
          tradeName: "Nome Fantasia",
          cnpj: "CNPJ",
          responsible: "Responsável",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Cadastrar cliente",
          edit: "Editar cliente",
        },
      },
      validation: {
        cnpjRequired: "CNPJ é obrigatório",
        cnpjInvalid: "CNPJ inválido. Formato esperado: 00.000.000/0000-00",
        companyRequired: "Empresa é obrigatória",
        tradeNameRequired: "Nome Fantasia é obrigatório",
        companyPhoneRequired: "Telefone da empresa é obrigatório",
        telefoneInvalid: "Telefone inválido. Formato esperado: (00) 00000-0000",
        municipalRegistrationRequired: "Inscrição Municipal é obrigatória",
        logoRequired: "Logo é obrigatória",
        logoInvalidType: "Logo deve ser uma imagem JPEG, JPG ou PNG",
        zipCodeRequired: "CEP é obrigatório",
        zipCodeInvalid: "CEP inválido. Formato esperado: 00000-000",
        streetRequired: "Logradouro é obrigatório",
        neighborhoodRequired: "Bairro é obrigatório",
        numberRequired: "Número é obrigatório",
        numberInvalid: "Informe um número inteiro válido",
        cityRequired: "Cidade é obrigatória",
        stateRequired: "Estado é obrigatório",
        countryRequired: "País é obrigatório",
        responsibleNameRequired: "Nome do responsável é obrigatório",
        responsibleEmailRequired: "Email do responsável é obrigatório",
        emailInvalid: "Email inválido",
        responsiblePhoneRequired: "Telefone do responsável é obrigatório",
      },
    },
    structures: {
      button: {
        new: "Nova Estrutura",
        save: "Salvar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Excluir",
        filter: "Filtrar",
        clearFilters: "Limpar Filtros",
      },
      form: {
        section: {
          coordinates: "Coordenadas da Estrutura",
        },
        label: {
          structure: "Estrutura",
          name: "Nome",
          complex: "Complexo",
          complexName: "Complexo",
          coordinateSystem: "Sistema de Coordenadas",
          coordinateE: "Coordenada E",
          coordinateN: "Coordenada N",
          radiusKm: "Raio (Km)",
          client: "Cliente",
        },
        placeholder: {
          structure: "Nome da estrutura",
          coordinateSystem: "Selecione...",
          coordinateE: "Coordenada E",
          coordinateN: "Coordenada N",
          radiusKm: "0",
          name: "Nome da estrutura",
          complexSelect: "Selecione um complexo",
          filterName: "Digite o nome da estrutura",
          filterComplexName: "Digite o nome do complexo",
          filterStructure: "Digite o nome da estrutura",
          clientSelect: "Selecione um cliente",
        },
      },
      table: {
        column: {
          structure: "Estrutura",
          name: "Nome",
          complexName: "Complexo",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Cadastrar estrutura",
          edit: "Editar estrutura",
        },
      },
      validation: {
        nameRequired: "Nome é obrigatório",
        complexRequired: "Complexo é obrigatório",
        structureRequired: "Estrutura é obrigatória",
        coordinateSystemRequired: "Sistema de coordenadas é obrigatório",
        coordinateERequired: "Coordenada E é obrigatória",
        coordinateNRequired: "Coordenada N é obrigatória",
        radiusKmRequired: "Raio (Km) é obrigatório",
        radiusKmMustBeNumber: "Raio (Km) deve ser um número",
      },
    },
    log: {
      page: {
        title: "Logs",
        description: "Visualize a atividade do sistema e os logs de auditoria.",
      },
      button: {
        export: "Exportar",
      },
      form: {
        label: {
          columns: "Colunas",
          startDate: "Data Inicial",
          endDate: "Data Final",
        },
        placeholder: {
          columns: "Selecione as colunas...",
          searchColumns: "Buscar colunas...",
          notFound: "Nenhuma coluna encontrada",
          notMoreOptions: "Não há mais opções",
        },
      },
      columns: {
        user: "Usuário",
        action: "Ação",
        date: "Data",
        ip: "IP",
        module: "Módulo",
      },
      validation: {
        columnsRequired: "Colunas são obrigatórias",
        startDateRequired: "Data inicial é obrigatória",
        endDateRequired: "Data final é obrigatória",
        dateRangeInvalid:
          "A data final deve ser posterior ou igual à data inicial",
      },
    },
    licenses: {
      button: {
        new: "Nova Licença",
        save: "Salvar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Excluir",
        view: "Visualizar",
        filter: "Filtrar",
        clearFilters: "Limpar Filtros",
      },
      form: {
        label: {
          client: "Cliente",
          clientEmail: "Email Cliente",
          managerEmail: "Email Gerente GS3",
          complex: "Complexo",
          structure: "Estrutura",
          module: "Módulo",
          licenses: "Licenças",
          startDate: "Data de início",
          endDate: "Data final",
          notificationPeriods: "Período de notificação",
          days: "dias",
          tenant: "Tenant",
        },
        placeholder: {
          client: "Selecione um cliente",
          clientEmail: "email@cliente.com",
          managerEmail: "gerente@gs3.com",
          complex: "Selecione um complexo",
          structure: "Selecione uma estrutura",
          module: "Selecione um módulo",
          licenses: "0",
          notificationPeriods: "Adicionar período...",
          filterComplex: "Digite o nome do complexo",
          filterStructure: "Digite o nome da estrutura",
          filterModule: "Selecione um módulo",
          filterLicenses: "Digite a quantidade",
        },
      },
      table: {
        column: {
          complex: "Complexo",
          structure: "Estrutura",
          module: "Módulo",
          licenses: "Licenças",
          accessPeriod: "Período de acesso",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Cadastrar licença",
          edit: "Editar licença",
          view: "Detalhes da licença",
        },
      },
      validation: {
        clientRequired: "Cliente é obrigatório",
        clientEmailRequired: "Email do cliente é obrigatório",
        managerEmailRequired: "Email do gerente é obrigatório",
        emailInvalid: "Email inválido",
        complexRequired: "Complexo é obrigatório",
        structureRequired: "Estrutura é obrigatória",
        moduleRequired: "Módulo é obrigatório",
        licensesRequired: "Licenças é obrigatório",
        licensesInvalid: "Informe um número inteiro válido de licenças",
        startDateRequired: "Data de início é obrigatória",
        endDateRequired: "Data final é obrigatória",
        notificationPeriodsMax: "Máximo de 3 períodos de notificação",
        notificationPeriodAlreadyExists: "Este período já foi adicionado",
        notificationPeriodsMin: "Adicione pelo menos 1 período de notificação",
      },
    },
    releaseNotes: {
      button: {
        addNewVersion: "Adicionar nova versão",
        save: "Salvar",
        cancel: "Cancelar",
      },
      form: {
        label: {
          file: "Arquivo",
          version: "Versão do arquivo",
        },
        placeholder: {
          version: "Ex: 1.0.0",
        },
      },
      modal: {
        title: {
          create: "Adicionar nova versão",
        },
      },
      validation: {
        fileRequired: "Arquivo é obrigatório",
        fileInvalidType: "O arquivo deve ser um PDF",
        versionRequired: "Versão é obrigatória",
      },
    },
    termsOfUse: {
      noFileUploaded: "Ainda não existe arquivo enviado",
      button: {
        addNewVersion: "Adicionar nova versão",
        save: "Salvar",
        cancel: "Cancelar",
      },
      form: {
        label: {
          file: "Arquivo",
          version: "Versão do arquivo",
        },
        placeholder: {
          version: "Ex: 1.0.0",
        },
      },
      modal: {
        title: {
          create: "Adicionar nova versão",
        },
      },
      validation: {
        fileRequired: "Arquivo é obrigatório",
        fileTooLarge: "O arquivo deve ter no máximo 20MB",
        fileInvalidType: "O arquivo deve ser um PDF",
      },
    },
    privacyPolicy: {
      noFileUploaded: "Ainda não existe arquivo enviado",
      button: {
        addNewVersion: "Adicionar nova versão",
        save: "Salvar",
        cancel: "Cancelar",
      },
      form: {
        label: {
          file: "Arquivo",
          version: "Versão do arquivo",
        },
        placeholder: {
          version: "Ex: 1.0.0",
        },
      },
      modal: {
        title: {
          create: "Adicionar nova versão",
        },
      },
      validation: {
        fileRequired: "Arquivo é obrigatório",
        fileTooLarge: "O arquivo deve ter no máximo 20MB",
        fileInvalidType: "O arquivo deve ser um PDF",
      },
    },
  },
  home: {
    welcome: {
      title: "Bem-vindo(a) ao GS3",
      subtitle:
        "Selecione um módulo no menu lateral para começar.",
    },
    hero: {
      badge: "Sistema em desenvolvimento",
      tagline: "O futuro do monitoramento de barragens está chegando",
      subtitle:
        "Estamos construindo uma plataforma completa para gestão e monitoramento de segurança de barragens. Acompanhe o progresso de cada módulo abaixo.",
    },
    modules: {
      title: "Módulos do Sistema",
      badgeActive: "Em desenvolvimento",
      badgeSoon: "Em breve",
      badgeCompleted: "Concluído",
      progress: "Progresso",
      authenticationAndSecurity: {
        name: "Autenticação e Segurança",
        description:
          "Módulos de autenticação, autorização e gestão de usuários",
      },
      administrative: {
        name: "Administrativo",
        description: "Funcionalidades administrativas para usuários Admin",
      },
      general: { name: "Geral", description: "Visão geral do sistema" },
      monitoring: {
        name: "Monitoramento",
        description: "Monitoramento contínuo de instrumentos",
      },
      inspections: {
        name: "Inspeções",
        description: "Registro e gestão de inspeções de campo",
      },
      actionPlan: {
        name: "Plano de Ação",
        description: "Planos de ação e rastreamento de atividades",
      },
      stability: {
        name: "Estabilidade",
        description: "Análise de estabilidade de taludes",
      },
      eor: {
        name: "EoR",
        description: "Enquadramento e classificação de barragens",
      },
      ato: {
        name: "ATO",
        description: "Autorização de operação de estruturas",
      },
      psb: { name: "PSB", description: "Plano de segurança de barragem" },
      gistm: {
        name: "GISTM",
        description: "Padrão global de gestão de rejeitos",
      },
      paebm: { name: "PAEBM", description: "Plano de ação de emergência" },
      damBreak: {
        name: "Ruptura de Barragem",
        description: "Simulação de ruptura e zonas de autossalvamento",
      },
      riskAnalysis: {
        name: "Análise de Risco",
        description: "Avaliação e classificação de riscos",
      },
      report: { name: "Relatórios", description: "Geração de relatórios técnicos" },
      dashboard: {
        name: "Dashboard",
        description: "Painéis de indicadores e métricas",
      },
      cmg: { name: "CMG", description: "Gestão de manutenção e controle" },
      managerial: {
        name: "Gerencial",
        description: "Gestão de usuários, clientes e licenças",
      },
    },
    map: {
      title: "Área de cobertura monitorada",
    },
  },
  legalDocuments: {
    modal: {
      version: "Versão",
      accept: "Aceitar",
      termsOfUse: {
        title: "Termos de Uso",
        readConfirm: "Li e aceito os Termos de Uso",
      },
      privacyPolicy: {
        title: "Política de Privacidade",
        readConfirm: "Li e aceito a Política de Privacidade",
      },
    },
  },
  errors: {
    errorFallback: "Erro inesperado",
    error1: "Solicitação inválida. Atualize a página e tente novamente",
    error2: "Usuário não encontrado",
    error3: "Sua sessão expirou. Faça login novamente",
    error4: "Selecione uma organização para continuar",
    error5: "Organização selecionada não está disponível",
    error6: "Você não tem acesso a esta organização",
    error7: "Sessão expirada. Por favor, faça login novamente",
    error8: "Sua sessão expirou. Faça login novamente",
    error9:
      "Não foi possível validar seu dispositivo. Atualize a página e tente novamente",
    error10:
      "Não foi possível concluir. Atualize a página e tente novamente",
    error11:
      "Esta organização ainda não está disponível. Tente mais tarde ou contate o suporte",
    error12: "Você não tem permissão para esta ação",
    error13: "Já existe um usuário cadastrado com este e-mail",
    error14: "Já existe um ambiente cadastrado com este CNPJ",
    error15: "Tipo de arquivo não permitido",
    error16: "Arquivo muito grande (máximo 20 MB)",
    error17: "O envio do arquivo é obrigatório",
    error18: "Documento legal não encontrado",
    error19: "Você já aceitou este termo",
    error20: "Já existe um complexo cadastrado com este CNPJ",
    error21: "Complexo não encontrado",
    error22: "Já existe uma estrutura com este nome para o complexo selecionado",
    error23: "Estrutura não encontrada",
    error24: "Módulo selecionado não está disponível",
    error25: "A estrutura já possui uma licença vigente para este módulo",
    error26: "Licença não encontrada",
    error27: "Acesso negado",
    error28: "Recurso não encontrado",
    error29:
      "Este usuário não pode ser promovido a Super Admin (já possui um papel administrativo)",
    error30: "Este usuário não está como Super Admin",
    error31: "Este usuário já é admin deste complexo",
    error32:
      "Capacidade de licenças esgotada. Revogue uma alocação existente ou aumente o plano",
    error33: "Este usuário já possui esta licença alocada",
    error34:
      "Não é possível editar permissões deste usuário (papel administrativo)",
    error35: "Este módulo não está disponível na estrutura selecionada",
    error36: "Módulo selecionado é inválido para este contexto",
    error37:
      "Uma ou mais permissões selecionadas não existem para este módulo",
    error38: "Este perfil de usuário não recebe alocação de licença",
    error54:
      "Preencha todos os campos obrigatórios do alteamento antes de salvar",
    error55:
      "Revise os dados do alteamento: a elevação deve ser um número (ex.: 845,25), a data deve ser válida e o método deve ser da lista",
    error56: "Linha de alteamento não encontrada",
    error77: "Inspeção não encontrada",
    error78: "Participante da inspeção não encontrado",
    error79:
      "Filtros ou paginação inválidos. Ajuste os critérios e tente novamente",
    error80:
      "Não foi possível salvar. Revise os dados da ficha e tente novamente",
    error81: "Esta inspeção não pode ser alterada no estado atual",
    error82: "Esta inspeção não pode ser excluída",
    error83: "Não é possível finalizar esta inspeção agora",
    error84: "A data de uma inspeção programada não pode ser alterada",
    error85:
      "Complete a ficha e as evidências obrigatórias antes de finalizar",
    error86: "Todos os participantes precisam assinar antes de finalizar",
    error87: "Este participante não pode ser removido",
    error88:
      "Não foi possível enviar a foto. Verifique o tipo de arquivo e o estado da inspeção",
    error89:
      "Fonte de assinatura inválida. Escolha uma das fontes disponíveis",
    error90:
      "Não foi possível gerar o PDF. A inspeção continua em andamento. Tente finalizar novamente",
    error91: "O relatório PDF ainda não está disponível",
    error92: "Informe uma data de inspeção válida (não pode ser futura)",
    error93:
      "O nome de um participante cadastrado no sistema não pode ser alterado nesta ficha",
    error94:
      "Inspeção programada só pode ser editada no dia previsto",
    error97: "Este participante já está na inspeção",
    error98: "Solicitação inválida. Atualize a página e tente novamente",
    error99: "Solicitação inválida. Atualize a página e tente novamente",
    error100:
      "Idioma informado não é válido. Escolha um idioma do menu e tente novamente",
    error101: "Tema informado não é válido. Atualize a página e tente novamente",
    boundary: {
      network: {
        title: "Erro de conexão",
        message: "Não foi possível conectar ao servidor.",
        suggestion: "Verifique sua conexão com a internet e tente novamente.",
      },
      unexpected: {
        title: "Erro inesperado",
        message: "Ocorreu um erro inesperado. Tente novamente.",
        suggestion: "Se o problema persistir, entre em contato com o suporte.",
      },
      unknown: {
        title: "Erro desconhecido",
        message: "Ocorreu um erro inesperado.",
        suggestion: "Tente recarregar a página.",
      },
      unauthorized: {
        title: "Não autenticado",
        message: "Você precisa fazer login para acessar esta página.",
        suggestion: "Por favor, faça login e tente novamente.",
      },
      forbidden: {
        title: "Acesso negado",
        message: "Você não tem permissão para acessar este recurso.",
        suggestion:
          "Entre em contato com o administrador se precisar de acesso.",
      },
      notFound: {
        title: "Página não encontrada",
        message: "A página que você está procurando não existe.",
        suggestion: "Verifique o endereço ou volte para o início.",
      },
      serverError: {
        title: "Erro no servidor",
        message: "Ocorreu um erro interno no servidor.",
        suggestion: "Tente novamente em alguns instantes.",
      },
      serviceUnavailable: {
        title: "Serviço indisponível",
        message: "O servidor está temporariamente indisponível.",
        suggestion:
          "Estamos trabalhando para resolver isso. Tente novamente em breve.",
      },
      default: {
        title: "Erro",
        message: "Ocorreu um erro inesperado.",
      },
    },
    appBoundary: {
      title: "Algo deu errado",
      description: "Ocorreu um erro inesperado. Por favor, tente novamente.",
      details: "Detalhes do Erro:",
      stackTrace: "Stack Trace",
      retry: "Tentar Novamente",
      reload: "Recarregar Página",
      goHome: "Ir para início",
    },
  },
  admin: {
    tabs: {
      users: "Usuários",
      access: "Acessos",
      complexes: "Complexos",
      structures: "Estruturas",
      licenseInventory: "Licenças",
      licenseAssignments: "Alocações",
      permissions: "Permissões",
    },
    access: {
      page: {
        title: "Acessos",
        subtitle:
          "Gerencie quais usuários são Admins de complexos específicos.",
      },
      complexAdmins: {
        sectionTitle: "Admins de Complexo",
        sectionDescription:
          "Admins de Complexo têm permissões dentro de um complexo específico. Apenas o Owner pode atribuir.",
        button: {
          assign: "Atribuir admin de complexo",
          remove: "Remover",
        },
        filter: {
          allComplexes: "Todos os complexos",
          complexLabel: "Filtrar por complexo",
        },
        modal: {
          assignTitle: "Atribuir admin de complexo",
          removeTitle: "Remover admin de complexo",
          removeMessage:
            "Tem certeza que deseja remover esta atribuição? O usuário deixará de administrar este complexo.",
        },
        table: {
          filterButtonText: "Filtros",
          column: {
            user: "Usuário",
            email: "Email",
            complex: "Complexo",
            createdAt: "Atribuído em",
          },
          empty: "Nenhuma atribuição cadastrada.",
        },
      },
      form: {
        label: {
          user: "Usuário",
          complex: "Complexo",
        },
        placeholder: {
          selectUser: "Selecione um usuário...",
          selectComplex: "Selecione um complexo...",
        },
        validation: {
          userRequired: "Selecione um usuário",
          complexRequired: "Selecione um complexo",
        },
        empty: {
          eligibleUsers:
            "Nenhum usuário elegível disponível.",
        },
      },
      forbidden:
        "Você não tem permissão para visualizar esta aba.",
    },
    complexes: {
      page: {
        title: "Complexos",
        subtitle: "Visualize os complexos disponíveis no seu tenant.",
      },
      button: {
        viewDetails: "Ver detalhes",
        close: "Fechar",
        filter: "Filtrar",
        clearFilters: "Limpar Filtros",
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          name: "Nome",
          fantasyName: "Nome Fantasia",
          cnpj: "CNPJ",
          responsibleName: "Responsável",
        },
      },
      filter: {
        label: {
          name: "Nome",
          fantasyName: "Nome Fantasia",
          cnpj: "CNPJ",
          responsibleName: "Responsável",
        },
        placeholder: {
          name: "Digite o nome",
          fantasyName: "Digite o nome fantasia",
          cnpj: "Digite o CNPJ",
          responsibleName: "Digite o nome do responsável",
        },
      },
      details: {
        title: "Detalhes do complexo",
        section: {
          identification: "Identificação",
          contact: "Contato",
          address: "Endereço",
        },
        label: {
          name: "Nome",
          fantasyName: "Nome Fantasia",
          cnpj: "CNPJ",
          municipalRegistration: "Inscrição Municipal",
          complexPhone: "Telefone do complexo",
          responsibleName: "Responsável",
          responsiblePhone: "Telefone",
          phone: "Telefone",
          zipCode: "CEP",
          street: "Rua",
          number: "Número",
          complement: "Complemento",
          neighborhood: "Bairro",
          city: "Cidade",
          state: "Estado",
          country: "País",
        },
        empty: "Sem informações de endereço.",
        notProvided: "—",
        loadError: "Erro ao carregar os detalhes do complexo.",
      },
    },
    structures: {
      page: {
        title: "Estruturas",
        subtitle:
          "Visualize as estruturas de cada complexo. Selecione um complexo para começar.",
      },
      complexSelector: {
        label: "Complexo",
        placeholder: "Selecione um complexo...",
        empty: "Selecione um complexo no seletor acima para ver as estruturas.",
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          name: "Nome",
          type: "Tipo",
          operationalStatus: "Status operacional",
          coordinateX: "Coordenada X",
          coordinateY: "Coordenada Y",
          actions: "Ações",
        },
        action: {
          details: "Detalhes",
        },
      },
      filter: {
        label: {
          name: "Nome",
          type: "Tipo",
          operationalStatus: "Status operacional",
        },
        placeholder: {
          name: "Digite o nome",
          type: "Selecione o tipo",
          operationalStatus: "Selecione o status",
        },
        button: {
          filter: "Filtrar",
          clearFilters: "Limpar Filtros",
        },
      },
      structureType: {
        dam: "Barragem",
        stockpile: "Pilha",
        openPit: "Cava",
      },
      operationalStatus: {
        decommissioned: "Descaracterizado",
        underConstruction: "Em Construção",
        inOperation: "Em Operação",
        underConstructionAndOperation: "Em Construção/Operação",
        underDecommissioning: "Em Descaracterização",
        halted: "Paralisado",
      },
      modal: {
        title: "Cadastrar dados da estrutura",
        button: {
          close: "Fechar",
          cancel: "Cancelar",
          save: "Salvar",
        },
        tab: {
          generalData: "Dados gerais",
          raisingHistory: "Histórico de alteamento",
          geometryDam: "Geometria do maciço",
          geometry: "Geometria",
          hydrology: "Hidrologia",
          reservoirManagement: "Manejo do reservatório",
          anmClassification: "Classificação ANM",
          regionalClassification: "Classificação regional",
          riskMapping: "Mapeamento de risco",
        },
      },
      generalData: {
        label: {
          name: "Nome",
          type: "Tipo",
          responsibleCompany: "Empresa responsável",
          operationalStatus: "Status operacional",
          operationStartDate: "Início da operação",
          operationEndDate: "Fim da operação",
          centralPointSystem: "Sistema de coordenadas",
          centralPointE: "Coordenada E",
          centralPointN: "Coordenada N",
          pinSystem: "Sistema de coordenadas",
          pinE: "Coordenada E",
          pinN: "Coordenada N",
          utmEnabled: "UTM",
          utmZone: "Zona UTM",
          utmHemisphere: "Hemisfério",
          orthophoto: "Ortofoto",
        },
        section: {
          centralPointDam: "Coordenadas do ponto central da crista",
          centralPointTop: "Coordenadas do ponto central do topo",
          pin: "Coordenadas do pin",
          pinInfoTooltip:
            "Coordenadas opcionais usadas apenas para centralizar o mapa na estrutura. Quando as coordenadas oficiais do ponto central não ficam visualmente no centro, o pin ajusta o marcador no mapa sem alterar os dados cadastrais.",
          pinInfoAriaLabel: "Informações sobre coordenadas do pin",
        },
        coordinateSystem: {
          sirgas2000: "SIRGAS2000",
          astrochua: "ASTROCHUA",
          corregoAlegre: "CORREGO ALEGRE",
          sad69: "SAD69",
          wgs84: "WGS84",
        },
        utmHemisphere: {
          north: "Norte",
          south: "Sul",
        },
        button: {
          uploadOrthophoto: "Enviar ortofoto",
        },
        placeholder: {
          type: "Selecione o tipo",
          orthophoto: "Selecione um arquivo .tif",
        },
        validation: {
          typeRequired: "Selecione o tipo da estrutura",
          responsibleCompanyRequired: "Informe a empresa responsável",
          operationalStatusRequired: "Selecione o status operacional",
          operationStartDateRequired: "Informe a data de início da operação",
          centralPointSystemRequired:
            "Selecione o sistema de coordenadas do ponto central",
          centralPointERequired: "Informe a coordenada E do ponto central",
          centralPointNRequired: "Informe a coordenada N do ponto central",
          pinGroupIncomplete:
            "Preencha todos os campos do pin ou deixe o grupo inteiro vazio",
          utmZoneRequired: "Informe a zona UTM",
          utmHemisphereRequired: "Selecione o hemisfério UTM",
          utmZoneOutOfRange: "A zona UTM deve estar entre 1 e 60",
          formInvalidTitle: "Preencha os campos obrigatórios",
          formInvalidDescription:
            "Corrija os campos destacados abaixo antes de salvar.",
          decimalInvalid:
            "Informe um número válido (use ponto ou vírgula como separador decimal)",
        },
      },
      geometry: {
        label: {
          crestElevation: "Elevação da crista (m)",
          damHeight: "Altura da barragem (m)",
          crestLength: "Comprimento da crista (m)",
          crestWidth: "Largura da crista (m)",
          typicalBermWidth: "Largura típica das bermas (m)",
          upstreamSlopeInclination: "Inclinação talude montante (°)",
          downstreamSlopeInclination: "Inclinação talude jusante (°)",
          betweenBermsSlopeInclination: "Inclinação talude entre bermas (°)",
          globalDownstreamSlopeInclination: "Inclinação talude global jusante (°)",
          benchSlopeInclination: "Inclinação do talude de bancada (°)",
          globalSlopeInclination: "Inclinação do talude global (°)",
          pitHeight: "Altura (m)",
          sectors: "Setores",
          benchHeight: "Altura das bancadas (m)",
          benchInclination: "Inclinação das bancadas (°)",
          referenceDocument: "Documento de referência",
        },
        validation: {
          crestElevationRequired: "Informe a elevação da crista",
          damHeightRequired: "Informe a altura da barragem",
          crestLengthRequired: "Informe o comprimento da crista",
          crestWidthRequired: "Informe a largura da crista",
          typicalBermWidthRequired: "Informe a largura típica das bermas",
          upstreamSlopeInclinationRequired: "Informe a inclinação do talude montante",
          downstreamSlopeInclinationRequired: "Informe a inclinação do talude jusante",
          betweenBermsSlopeInclinationRequired:
            "Informe a inclinação do talude entre bermas",
          globalDownstreamSlopeInclinationRequired:
            "Informe a inclinação do talude global jusante",
          benchSlopeInclinationRequired: "Informe a inclinação do talude de bancada",
          globalSlopeInclinationRequired: "Informe a inclinação do talude global",
          sectorsRequired: "Informe os setores",
          sectorsInvalid: "Informe um número inteiro maior ou igual a zero",
          pitHeightRequired: "Informe a altura",
          benchHeightRequired: "Informe a altura das bancadas",
          benchInclinationRequired: "Informe a inclinação das bancadas",
          referenceDocumentRequired: "Informe o documento de referência",
          decimalInvalid:
            "Informe um número válido (use ponto ou vírgula como separador decimal)",
        },
      },
      raisingHistory: {
        label: {
          raisingCount: "Número de alteamentos",
          executiveProjectDesigner: "Projeto Executivo (Projetista)",
          stage: "Etapa",
          method: "Método",
          elevation: "Elevação (m)",
          elevationShort: "Elevação",
          occurredOn: "Data",
        },
        method: {
          downstream: "Jusante",
          upstream: "Montante",
          centerLine: "Linha de centro",
        },
        button: {
          register: "Cadastrar",
          edit: "Editar",
          delete: "Excluir",
          confirm: "Confirmar",
        },
        table: {
          filterButtonText: "Filtrar",
        },
        filter: {
          label: {
            stage: "Etapa",
            method: "Método",
          },
          placeholder: {
            stage: "Filtrar por etapa",
            method: "Filtrar por método",
          },
          button: {
            clearFilters: "Limpar filtros",
          },
        },
        modal: {
          createTitle: "Novo alteamento",
          editTitle: "Editar alteamento",
          deleteTitle: "Excluir alteamento",
          deleteMessage: "Deseja excluir este alteamento?",
        },
        validation: {
          executiveProjectDesignerRequired:
            "Informe o projeto executivo (projetista)",
          stageRequired: "Informe a etapa",
          methodRequired: "Selecione o método",
          elevationRequired: "Informe a elevação",
          elevationInvalid:
            "Informe a elevação em metros usando apenas números (ex.: 845,25)",
          occurredOnRequired: "Informe a data",
          occurredOnInvalid: "Informe uma data válida",
        },
      },
      reservoirManagement: {
        label: {
          occupiedArea: "Área ocupada pelo reservatório (m²)",
          occupiedAreaShort: "Área ocupada (m²)",
          totalVolume: "Volume total do reservatório (m³)",
          totalVolumeShort: "V. total (m³)",
          totalOccupiedVolume: "Volume total ocupado (m³)",
          totalOccupiedVolumeShort: "V. total ocupado (m³)",
          availableVolume: "Volume disponível (m³)",
          availableVolumeShort: "V. disponível (m³)",
          rejectOccupiedVolume: "Volume ocupado por rejeito (m³)",
          rejectOccupiedVolumeShort: "V. ocupado rejeito (m³)",
          waterOccupiedVolume: "Volume ocupado por água (m³)",
          waterOccupiedVolumeShort: "V. ocupado por água (m³)",
          waterLevel: "Nível d'água",
          recordedOn: "Data",
        },
        button: {
          register: "Cadastrar",
          edit: "Editar",
          delete: "Excluir",
          confirm: "Confirmar",
        },
        table: {
          filterButtonText: "Filtrar",
        },
        filter: {
          label: {
            recordedOn: "Data",
          },
          button: {
            clearFilters: "Limpar filtros",
          },
        },
        modal: {
          createTitle: "Novo manejo",
          editTitle: "Editar manejo",
          deleteTitle: "Excluir manejo",
          deleteMessage: "Deseja excluir este registro de manejo?",
        },
        validation: {
          occupiedAreaRequired: "Informe a área ocupada pelo reservatório",
          occupiedAreaInvalid: "Informe a área ocupada usando apenas números",
          totalVolumeRequired: "Informe o volume total do reservatório",
          totalVolumeInvalid: "Informe o volume total usando apenas números",
          totalOccupiedVolumeRequired: "Informe o volume total ocupado",
          totalOccupiedVolumeInvalid:
            "Informe o volume total ocupado usando apenas números",
          availableVolumeRequired: "Informe o volume disponível",
          availableVolumeInvalid:
            "Informe o volume disponível usando apenas números",
          rejectOccupiedVolumeRequired:
            "Informe o volume ocupado por rejeito",
          rejectOccupiedVolumeInvalid:
            "Informe o volume ocupado por rejeito usando apenas números",
          waterOccupiedVolumeRequired: "Informe o volume ocupado por água",
          waterOccupiedVolumeInvalid:
            "Informe o volume ocupado por água usando apenas números",
          waterLevelRequired: "Informe o nível d'água",
          waterLevelInvalid: "Informe o nível d'água usando apenas números",
          recordedOnRequired: "Informe a data",
          recordedOnInvalid: "Informe uma data válida",
        },
      },
      anmClassification: {
        classification: {
          high: "Alto",
          medium: "Médio",
          low: "Baixo",
        },
        label: {
          criBignumberTitle: "Classificação de risco (CRI)",
          dpaBignumberTitle: "Dano potencial (DPA)",
          goBignumberTitle: "Gestão operacional (GO)",
          referenceDocButton: "Documentação de referência {{section}}",
          referenceDocPanel: "Documentação de referência — {{section}}",
          close: "Fechar",
          total: "Total {{section}}",
          classificationStatus: "Classificação {{section}}",
          partial: "Parcial {{grade}}",
          points: "Pontos",
          classification: "Classificação",
          criterion: "Critério",
          band: "Faixa",
          riskCategory: "Categoria de risco",
          riskCategoryCri: "Categoria de risco (CRI)",
        },
        criPanel: {
          tableTitle: "Quadro 1 - Classificação para barragens de mineração",
          ctRow: "Características técnicas (CT)",
          ecRow: "Estado de conservação (EC)",
          psRow: "Plano de segurança de barragens (PS)",
          totalFormula: "Pontuação total (CRI) = CT + EC + PS",
          riskClassification: "Classificação de risco",
          bandsTitle: "Faixas de classificação",
          bandHigh: ">= 80 ou EC = 10 (*)",
          bandMedium: "40 < CRI < 80",
          bandLow: "<= 40",
          footnote:
            "(*) Pontuação (10) em qualquer coluna de estado de conservação (EC) implica automaticamente CATEGORIA DE RISCO ALTA e necessidade de previdências imediatas pelo responsável pela barragem",
        },
        dpaPanel: {
          tableTitle: "Classificação para barragens de mineração",
          damageCategoryDpa: "Dano potencial associado (DPA)",
          volumeRow: "Volume total do reservatório",
          populationRow: "Existência de População à Jusante",
          environmentalRow: "Impacto Ambiental",
          socioeconomicRow: "Impacto Socioeconômico",
          totalLabel: "Pontuação total (DPA)",
          damageClassification: "Classificação de dano",
          bandsTitle: "Faixas de classificação",
          damageCategory: "Dano potencial associado",
          bandHigh: ">= 13",
          bandMedium: "7 < DPA < 13",
          bandLow: "<= 7",
          matrixFooter: "Matriz de classificação",
        },
        goClassification: {
          aa: "AA",
          a: "A",
          b: "B",
          c: "C",
          d: "D",
        },
        goPanel: {
          tableTitle: "Quadro 6 - Classificação quanto à gestão operacional",
          operationalCategory: "Gestão operacional (GO)",
          risrRow: "Declaração de Condição de Estabilidade RISR enviada",
          rpsbRow: "Declaração de Condição de Estabilidade RPSB enviada",
          conformityRow: "Declaração de Conformidade e Operacionalidade enviada",
          inspectionRow: "Extrato de Inspeção enviado",
          edrRow: "Existência de EdR",
          pgrbmRow: "Programa de Gestão de Risco para Barragens de Mineração — PGRBM",
          certificationRow: "Certificação e/ou padrões da indústria",
          totalLabel: "Pontuação total (GO)",
          operationalClassification: "Classificação de gestão operacional",
          bandsTitle: "Faixas de classificação",
          gopCategory: "GOP",
          bandAa: "0",
          bandA: "1 a 7",
          bandB: "8 a 35",
          bandC: "36 a 59",
          bandD: ">= 60 (*)",
          footnote:
            "(*) Barragem que deveria estar cadastrada no CNBM sendo descoberta em ação fiscalizatória permanecerá em classe D por 6 meses subsequentes.",
        },
        validation: {
          incompleteSelectionTitle: "Seleção incompleta",
          incompleteSelectionDescription:
            "Selecione um card em cada coluna de todas as grades (CRI, DPA e Gestão operacional) antes de salvar.",
        },
        catalog: anmClassificationCatalogPtBR,
      },
      regionalClassification: {
        classification: {
          high: "Alto",
          medium: "Médio",
          low: "Baixo",
        },
        state: {
          label: "Estado",
          placeholder: "Selecione o estado",
          mg: "Minas Gerais",
        },
        norm: {
          label: "Norma",
          placeholder: "Selecione a norma",
          locked: "Norma fixada após o primeiro salvamento.",
        },
        label: {
          criBignumberTitle: "Categoria de risco (CRI)",
          secondBignumberTitle: "Dano potencial",
          referenceDocButton: "Documentação de referência {{section}}",
          referenceDocPanel: "Documentação de referência — {{section}}",
          close: "Fechar",
          total: "Total {{section}}",
          classificationStatus: "Classificação {{section}}",
          partial: "Parcial {{grade}}",
          points: "Pontos",
          classification: "Classificação",
          criterion: "Critério",
          band: "Faixa",
          riskCategory: "Categoria de risco",
          riskCategoryCri: "Categoria de risco (CRI)",
        },
        criPanel: {
          sectionRowNumber: "1",
          gradeRowNumber: "1.{{index}}",
          totalFormula: "Pontuação total (CRI) = CT + EC + PSB",
          bandsTitle: "Faixas de classificação",
          bandHigh: ">= {{highMin}} ou EC = {{ecScore}} (*)",
          bandMedium: "{{mediumMin}} < CRI < {{highMin}}",
          bandLow: "<= {{mediumMin}}",
          footnote:
            "(*) Pontuação ({{ecScore}}) ou superior em qualquer coluna de estado de conservação (EC) implica automaticamente CATEGORIA DE RISCO ALTA e necessidade de previdências imediatas pelo responsável pela barragem",
        },
        secondPanel: {
          sectionRowNumber: "2",
          criterionRowNumber: "2.{{index}}",
          damageCategory: "Dano potencial associado ({{section}})",
          totalLabel: "Pontuação total ({{section}})",
          damageClassification: "Classificação de dano",
          bandsTitle: "Faixas de classificação",
          bandHigh: ">= {{highMin}}",
          bandMedium: "{{mediumMin}} < {{section}} < {{highMin}}",
          bandLow: "<= {{mediumMin}}",
          matrixFooter: "Matriz de classificação",
        },
        validation: {
          incompleteSelectionTitle: "Seleção incompleta",
          incompleteSelectionDescription:
            "Selecione um card em cada coluna de todas as grades (CRI e PDA/DPA) antes de salvar.",
          stateRequired: "Selecione o estado",
          normRequired: "Selecione a norma",
          normLocked: "A norma não pode ser alterada após o primeiro salvamento.",
        },
        catalog: regionalClassificationCatalogPtBR,
      },
      riskMapping: {
        label: {
          wasteType: "Tipo de resíduos",
          downstreamHumanOccupation:
            "Ocupação humana a jusante da barragem",
          downstreamEnvironmentalInterest:
            "Interesse ambiental na área jusante da barragem",
          downstreamInstallation:
            "Instalação na área a jusante da barragem",
        },
        validation: {
          wasteTypeRequired: "Informe o tipo de resíduos",
          downstreamHumanOccupationRequired:
            "Informe a ocupação humana a jusante da barragem",
          downstreamEnvironmentalInterestRequired:
            "Informe o interesse ambiental na área jusante da barragem",
          downstreamInstallationRequired:
            "Informe a instalação na área a jusante da barragem",
        },
      },
      hydrology: {
        label: {
          maximumMaximorumLevel: "N.A. Máximo maximorum (m)",
          criticalDuration: "Duração crítica (h)",
          inflowRate: "Vazão afluente (m³/s)",
          outflowRate: "Vazão efluente (m³/s)",
          designRainfall: "Chuva de projeto (mm)",
          contributingBasinArea: "Bacia de contribuição (km²)",
          returnPeriod: "Tempo de retorno (anos)",
          totalVolumeAtCrestElevation: "Volume total na elevação da crista (m³)",
          spillwayType: "Tipo de extravasor",
          spillwaySill: "Soleira do extravasor (mm)",
          referenceDocument: "Documento de referência",
        },
        spillwayType: {
          surface: "Superfície",
          tulip: "Tulipa",
          lateralChannel: "Canal lateral",
          labyrinth: "Labirinto",
          gated: "Com comportas",
          bottom: "Fundo",
        },
        validation: {
          maximumMaximorumLevelRequired: "Informe o N.A. máximo maximorum",
          criticalDurationRequired: "Informe a duração crítica",
          inflowRateRequired: "Informe a vazão afluente",
          outflowRateRequired: "Informe a vazão efluente",
          designRainfallRequired: "Informe a chuva de projeto",
          contributingBasinAreaRequired: "Informe a bacia de contribuição",
          returnPeriodRequired: "Informe o tempo de retorno",
          totalVolumeAtCrestElevationRequired:
            "Informe o volume total na elevação da crista",
          spillwayTypeRequired: "Selecione o tipo de extravasor",
          spillwaySillRequired: "Informe a soleira do extravasor",
          referenceDocumentRequired: "Informe o documento de referência",
          decimalInvalid:
            "Informe um número válido (use ponto ou vírgula como separador decimal)",
        },
      },
    },
    users: {
      button: {
        new: "Novo Usuário",
        save: "Salvar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Excluir",
        filter: "Filtrar",
        clearFilters: "Limpar Filtros",
      },
      form: {
        label: {
          name: "Nome",
          email: "Email",
          phone: "Telefone",
          department: "Setor",
          position: "Função",
          userType: "Tipo de usuário",
        },
        placeholder: {
          name: "Nome Sobrenome",
          email: "nome@empresa.com",
          emailTellus: "nome.sobrenome@telluscompany.com.br",
          userTypeSelect: "Selecione...",
          department: "Engenharia digital",
          position: "UX/UI Designer",
          filterName: "Digite o nome",
          filterEmail: "Digite o email",
        },
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          name: "Nome",
          email: "Email",
          role: "Tipo de Acesso",
          userType: "Tipo",
          department: "Setor",
          position: "Função",
        },
      },
      modal: {
        title: {
          create: "Cadastrar usuário",
          edit: "Editar usuário",
        },
      },
      userType: {
        client: "Cliente",
        tellus: "Tellus",
      },
      validation: {
        nameRequired: "Nome é obrigatório (mínimo 2 caracteres)",
        emailRequired: "Email é obrigatório",
        emailInvalid: "Email inválido",
        emailTellusDomain: "O email deve pertencer ao domínio @telluscompany.com.br",
        phoneRequired: "Telefone é obrigatório (mínimo 8 caracteres)",
      },
    },
    licenseInventory: {
      page: {
        title: "Inventário de licenças",
        subtitle:
          "Visualize as licenças contratadas por complexo, estrutura e módulo, com quantidades totais, usadas e disponíveis.",
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          complex: "Complexo",
          structure: "Estrutura",
          module: "Módulo",
          validity: "Vigência",
          quantity: "Total",
          used: "Usadas",
          available: "Disponíveis",
        },
      },
      filter: {
        label: {
          complex: "Complexo",
          structure: "Estrutura",
          module: "Módulo",
          onlyActive: "Somente licenças vigentes",
        },
        placeholder: {
          complex: "Digite o nome do complexo",
          structure: "Digite o nome da estrutura",
          module: "Digite o nome do módulo",
        },
        button: {
          filter: "Filtrar",
          clearFilters: "Limpar Filtros",
        },
      },
    },
    licenseAssignments: {
      page: {
        title: "Alocações de licença",
        subtitle:
          "Aloque e revogue licenças para usuários do tenant. Cada alocação consome uma unidade da quantidade contratada.",
      },
      button: {
        assign: "Alocar licença",
        revoke: "Revogar",
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          assigneeName: "Usuário",
          assigneeEmail: "Email",
          complex: "Complexo",
          structure: "Estrutura",
          module: "Módulo",
          validity: "Vigência",
        },
      },
      filter: {
        label: {
          complex: "Complexo",
          structure: "Estrutura",
          module: "Módulo",
          user: "Usuário",
        },
        placeholder: {
          complex: "Digite o nome do complexo",
          structure: "Digite o nome da estrutura",
          module: "Digite o nome do módulo",
          user: "Digite o nome do usuário",
        },
        button: {
          filter: "Filtrar",
          clearFilters: "Limpar Filtros",
        },
      },
      modal: {
        assignTitle: "Alocar licença",
        revokeTitle: "Revogar alocação",
        revokeMessage:
          "Tem certeza que deseja revogar esta alocação? A licença ficará disponível novamente.",
      },
      form: {
        label: {
          user: "Usuário",
          license: "Licença (complexo / estrutura / módulo)",
        },
        placeholder: {
          selectUser: "Selecione um usuário...",
          selectLicense: "Selecione uma licença...",
        },
        validation: {
          userRequired: "Selecione um usuário",
          licenseRequired: "Selecione uma licença",
        },
        licenseOption: {
          available: "disponíveis",
        },
        licenseEmpty: "Nenhuma licença vigente disponível.",
      },
    },
    permissions: {
      page: {
        title: "Permissões granulares",
        subtitle:
          "Defina, para cada usuário, quais ações ele pode executar em cada módulo de uma estrutura específica.",
      },
      form: {
        label: {
          complex: "Complexo",
          structure: "Estrutura",
          user: "Usuário",
        },
        placeholder: {
          selectComplex: "Selecione um complexo...",
          selectStructure: "Selecione uma estrutura...",
          selectUser: "Selecione um usuário...",
        },
      },
      empty: {
        selectAll: "Selecione complexo, estrutura e usuário para continuar.",
      },
      error: {
        load: "Erro ao carregar as permissões. Verifique se você tem acesso ao complexo selecionado.",
      },
      grid: {
        empty: "Nenhum módulo disponível para esta combinação.",
        badge: {
          unavailable: "Indisponível nesta estrutura",
        },
        module: {
          noKeys: "Nenhuma chave de permissão definida para este módulo.",
        },
      },
      button: {
        save: "Salvar permissões",
      },
    },
  },
};
